/** Organisation settings keyed by full setting key (e.g. organisation.base_currency). */
export type OrganisationSettings = Record<string, string | number | boolean | unknown[] | null>;

export interface OrganisationSettingsDefaults {
  baseCurrency: string;
  currencySymbol: string;
  timezone: string;
  dateFormat: string;
}

export const ORGANISATION_SETTING_KEYS = {
  baseCurrency:  'organisation.base_currency',
  currencySymbol:'organisation.currency_symbol',
  timezone:      'organisation.timezone',
  dateFormat:    'organisation.date_format',
  name:          'organisation.name',
  logoPath:      'organisation.logo_path',
  faviconPath:   'organisation.favicon_path',
} as const;
